import { Component, Vue } from "vue-property-decorator";
import menuContent from './components/menuContent.vue'
import InventoryStatistics from './components/InventoryStatistics'
import TransferRecord from './components/TransferRecord'
import { EmployeeSearchDTO, EmployeeServiceProxy } from '@/service-proxies/app-v2/employee.service-proxies';
import { AuthorityDomainServiceProxy } from '@/service-proxies/app-v2/system.service-proxies';
import { StockInTypeServiceProxy, StockOutTypeServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies';

const esp = new EmployeeServiceProxy()
const adsp = new AuthorityDomainServiceProxy()
const sotsp = new StockOutTypeServiceProxy()
const skitsp = new StockInTypeServiceProxy()
@Component({
  components: {
    menuContent,
    InventoryStatistics,
    TransferRecord
  }
})
export default class StatisticalReport extends Vue {
  get menus(){
    return [
      {value: 'inventoryStatistics', label: 'page_meterial_inventory_tatistics'},
      {value: 'analysisSetting', label: 'page_meterial_analysis_setting'},
    ]
  }
  selectKeys = []
  currentMenu:any = {}
  employeesList = []
  outTypeList = []
  stockInList = []
  listAllTree = []
  
  changeItem(item) {
    this.selectKeys = []
    this.changeSelect(item)
  }

  created(){
    esp.getPageEmployees(1,{statusList: [1]} as EmployeeSearchDTO,"",999999).then(res =>{
      this.employeesList = res.records
    })
    sotsp.getStockOutTypeList().then(res =>{
      this.outTypeList = res
    })
    skitsp.getStockInTypeList().then(res =>{
      this.stockInList = res
    })
    adsp.treeList().then(res =>{
      const arr:any = res.data
      arr.forEach(item => {
        this.filterData(item)
      })
    })
    console.log(this.$route,'created')
    if(this.$route.path == '/material/basics/statisticalReport/stock') {
      this.currentMenu.value == "inventoryStatistics"
      this.selectKeys = ['inventoryStatistics']
    }
    else if(this.$route.path == '/material/basics/statisticalReport/record') {
      this.currentMenu.value == "analysisSetting"
      this.selectKeys = [ 'analysisSetting']
    }
  }

  filterData(item: any) {
    const arr = {
      title: item.title,
      value: item.id,
      key: item.id,
    }
    this.listAllTree.push(arr)
    if (item.children && item.children.length > 0) {
      item.children.forEach(res =>{
        this.filterData(res)
      })
    }
  }

  changeSelect(item){
    this.currentMenu = item
    this.selectKeys.push(this.currentMenu.value)
    console.log(item,'aa')
  }

  render() {
    return (
      <menu-content i18n={true} menus={this.menus} selectKeys={this.selectKeys} onChangeItem={value => this.changeItem(value)}>
        <template slot="right">
          <div class="main-con" style="height: 100%">
            {this.currentMenu.value === 'inventoryStatistics' ? <inventory-statistics employeesList={this.employeesList}></inventory-statistics> : null }
            {this.currentMenu.value === 'analysisSetting' ? 
              <transfer-record
                employeesList={this.employeesList}
                outTypeList={this.outTypeList}
                stockInList={this.stockInList}
                listAllTree={this.listAllTree}
              ></transfer-record> : null }
          </div>
        </template>
      </menu-content>
    )
  }
}